/* eslint-disable jira/filename-case */
import { fg } from '@atlassian/jira-feature-gating';

const isIframePreviewPanelInSubtasksEnabled = {
	get(): boolean {
		return fg('issue_preview_panel_issue_view_subtask');
	},
};

export default isIframePreviewPanelInSubtasksEnabled;
